exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.categorized .v-list__group--active {\n  border: 1px solid rgba(0, 0, 0, 0.664);\n}\n", ""]);

// exports
